import { useEffect, useState } from "react";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { Newspaper, Calendar } from "lucide-react";

const CATEGORIES = [["", "All"], ["federation", "Federation"], ["circular", "Circulars"], ["press", "Press"], ["national", "National"], ["international", "International"]];

export default function News() {
  const [cat, setCat] = useState("");
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/news", { params: { category: cat || undefined } }).then((r) => setItems(r.data)); }, [cat]);
  return (
    <div data-testid="news-page">
      <PageHero eyebrow="News" title="Federation Updates & Circulars" subtitle="Official announcements, press releases and circulars from NKF Bharat." />
      <section className="section-spacing nkf-container">
        <div className="flex flex-wrap gap-2 mb-6">
          {CATEGORIES.map(([k, l]) => (
            <button key={k || "all"} onClick={() => setCat(k)} data-testid={`news-cat-${k || "all"}`}
              className={`px-3 py-1.5 text-[11px] uppercase tracking-widest rounded-full border ${cat === k ? "bg-nkf-blue text-white border-nkf-blue" : "bg-white border-slate-200 text-slate-700 hover:border-nkf-blue/40"}`}>{l}</button>
          ))}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((n) => (
            <article key={n.id} className="federation-card bg-white border border-slate-200 rounded-md overflow-hidden flex flex-col">
              <div className="aspect-video bg-slate-100 overflow-hidden">
                {n.image_url ? <img src={n.image_url} alt={n.title} className="w-full h-full object-cover" /> :
                  <div className="w-full h-full flex items-center justify-center text-slate-400"><Newspaper /></div>}
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <div className="text-[11px] uppercase tracking-widest text-nkf-red font-semibold">{n.category}</div>
                <h3 className="font-display text-lg text-nkf-blue leading-snug mt-1">{n.title}</h3>
                <p className="mt-2 text-sm text-slate-600 line-clamp-3">{n.body}</p>
                <div className="mt-4 pt-3 border-t border-slate-100 text-[11px] text-slate-500 flex items-center gap-2"><Calendar className="h-3 w-3" /> {(n.published_at || "").slice(0, 10)}</div>
              </div>
            </article>
          ))}
          {!items.length && <div className="col-span-full p-8 text-center text-slate-500 border border-dashed rounded-md">No news yet.</div>}
        </div>
      </section>
    </div>
  );
}
